// ------------------------------
// 全局 API 配置（只维护一次）
// ------------------------------

// 判断当前是否为正式主题（已发布）
window.isProduction = Shopify.theme && Shopify.theme.role === "main";

// 自动选择接口前缀（plugin = 正式站, tplugin = 测试站）
window.API_PREFIX = window.isProduction ? "plugin" : "tplugin";

// 全局统一 API 基础地址
window.API_BASE = `https://${window.API_PREFIX}.kriyya.com`;

console.log(
  `🌍 当前环境: ${window.isProduction ? "正式" : "测试"} → 使用接口前缀: ${
    window.API_PREFIX
  }`
);
